import React from 'react';
import PropTypes from 'prop-types';
import {
  CompanyDataDiv,
  SectionBox,
} from '../../AdminRoutes/Admin/Companies/CompaniesHome/CompanyHome.styles';
import AdminOnlyDetails from './Details/AdminOnlyDetails';
import CourseDetails from './Details/CourseDetails';
import UserAnswers from './UserAnswers';
import DeleteCourseFromUser from './DeleteCourse.component';
import CertificateDetails from './Certificates/CertificateDetails';
import SendReminderEmailButton from './SendReminderEmail';

const UserCourseDetails = ({ user, userId, courseId, course, userData }) => {
  if (!course) return null;
  // console.log(user, userId, courseId, course);

  return (
    <>
      <CompanyDataDiv>
        <SectionBox>
          <h3>User Course Details</h3>
          <div>
            <CourseDetails course={course} />
            {userData.type === 'Admin' && <AdminOnlyDetails c={course} />}
          </div>
        </SectionBox>
      </CompanyDataDiv>
      <CertificateDetails c={course} user={user} />
      <UserAnswers c={course} />
      {course?.complete === false && (
        <SendReminderEmailButton userId={user._id} courseId={course._id} />
      )}
      {userData.type === 'Admin' && (
        <DeleteCourseFromUser userId={userId} courseId={courseId} />
      )}
    </>
  );
};

UserCourseDetails.propTypes = {
  user: PropTypes.object,
  userId: PropTypes.string,
  courseId: PropTypes.string,
  course: PropTypes.object,
  userData: PropTypes.object,
};

export default UserCourseDetails;
